import { jsx, jsxs } from 'react/jsx-runtime';
import cn from 'classnames';
import { useMemo } from 'react';
import { Space, Tooltip, Icon } from '@sravni/react-design-system';
import { Text, Heading } from '@sravni/react-design-system/lib/Typography';
import { Tooltip as Tooltip$1 } from '@sravni/react-icons';
import modules_2e027b98 from './OfferParam.module.scss.js';

var OfferParam = function (_a) {
    var label = _a.label, value = _a.value, tooltip = _a.tooltip;
    var labelComponent = useMemo(function () {
        if (tooltip) {
            return (jsx(Text, { size: 12, className: "h-color-D60", children: jsxs(Space, { className: modules_2e027b98.nobreak, align: "center", size: 2, children: [label, jsx(Tooltip, { footer: tooltip, placement: "right", children: jsx(Icon, { size: 16, icon: jsx(Tooltip$1, {}) }) })] }) }));
        }
        return (jsx(Text, { size: 12, className: "h-color-D60", children: label }));
    }, [label, tooltip]);
    return (jsxs(Space, { direction: "vertical", size: 4, className: cn(modules_2e027b98.param), children: [labelComponent, typeof value === 'string' || value instanceof String ? (jsx(Heading, { className: modules_2e027b98.nobreak, level: 6, children: value })) : (value)] }));
};

export { OfferParam };
//# sourceMappingURL=OfferParam.js.map
